require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apprentis-0-5-2.json") })
        }
      }, "path---apprentis-0-5-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apprentis-0-5-2!./.cache/json/apprentis-0-5-2.json
// module id = 328
// module chunks = 231608221292675